export default {
    methods: {
        buildDataUri(dataType, dataBase64) {
            return `data:image/${dataType};base64,${dataBase64}`;
        },

        buildDataUriFromGoogle(pictureArray, index = 0) {
            if (!pictureArray) return '';

            let picture;
            if (!Array.isArray(pictureArray))
                picture = pictureArray;

            else if (pictureArray.length - 1 >= index && index >= 0)
                picture = pictureArray[index];

            if (picture && picture.ImageType && picture.ImageData)
                return this.buildDataUri(picture.ImageType, picture.ImageData);

            return '';
        }
    }
}
